module.exports = __webpack_public_path__ + "img/service-programmed.a9df5a5e.svg";